import {
    GetScheduleList,
    DeleteSchedule,
    CreateSchedule,
    GetSchedulue,
    UpdateSchedule,
    GetScheduleConfig,
    DeleteScheduleConfig,
} from '@src/services/schedule-map'

export const state = {
    scheduleList: [],
    scheduleConfig: [],
}

export const getters = {
    totalList(state) {
        return state.scheduleList.data
            ? state.scheduleList.data.totalItemCount
            : 0
    },
}

export const mutations = {
    SET_LIST(state, newList) {
        state.scheduleList = newList
    },
    ADD_SCHEDULE_CONFIG(state, newConfig) {
        state.scheduleConfig.unshift(newConfig)
    },
    DELETE_SCHEDULE_CONFIG(state, configId) {
        state.scheduleConfig = state.scheduleConfig.filter(
            ({ publicId }) => publicId !== configId
        )
    },
    CLEAR_STATE(state) {
        state.scheduleConfig = []
    },
}

export const actions = {
    async fetchList({ commit }, params = false) {
        const resp = await GetScheduleList(params)
        if (resp.status === 200) {
            commit('SET_LIST', resp.data)
        }
    },
    async deleteSchedule({ dispatch }, publicId) {
        const resp = await DeleteSchedule(publicId)
        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async createSchedule(_, schedule) {
        const resp = await CreateSchedule(schedule)
        return resp
    },
    async setScheduleForm({ commit }, schedulePublicId) {
        const resp = await GetSchedulue(schedulePublicId)
        // console.log(resp)
        if (resp.status === 200) {
            const respConfig = await GetScheduleConfig(resp.data.data.publicId)
            respConfig.data.data.forEach((config) => {
                config.update = true
                commit('ADD_SCHEDULE_CONFIG', config)
            })
        }
        return resp
    },
    async updateSchedule(_, schedule) {
        const resp = await UpdateSchedule(schedule)
        return resp
    },
    async removeScheduleConfig({ commit }, scheduleConfigId) {
        const resp = await DeleteScheduleConfig([scheduleConfigId])
        if (resp.status === 200)
            commit('DELETE_SCHEDULE_CONFIG', scheduleConfigId)
        return resp
    },
    clearState({ commit }) {
        commit('CLEAR_STATE')
    },
}
